import Drawer from "../../../../drawer/Drawer";
import ManagePaymentGetway from "../ManagePaymentGetway";

const ManagePaymentGetwayDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl2"}
      title={data?._id ? "Update Payment Getway" : "Add Payment Getway"}
      subtitle="View, update and modify user details and information bellow"
      drawerBodyclassName="p-0 max-h-[calc(100%-90px)]"
    >
      <div className="h-full overflow-y-auto">
        <ManagePaymentGetway
          getResponse={getResponse}
          close={close}
          data={data}
        />
      </div>
    </Drawer>
  );
};

export default ManagePaymentGetwayDrawer;
